import { form } from '../../formState'

import { DriversAccess } from './components/DriversAccess'
import { Header } from './components/Header'
import { VehiclesAccess } from './components/VehiclesAccess'

interface Props {
  territoriesData: uui.domain.client.rm.TerritoriesDriversAndVehicles
  territoryNames: Record<string, string>
}

export function CourierTerritoryDataAccess(props: Props) {
  const { territoriesData, territoryNames } = props
  const filters = form.useFormField('courierFilter')
  const filterValue = filters.field.value

  return (
    <form.Fieldset spacing={2}>
      {filterValue.map(territoryId => (
        <form.Fieldset spacing={1}>
          <Header territoryId={territoryId} territoryName={territoryNames[territoryId]} />
          <VehiclesAccess territoryId={territoryId} territoriesData={territoriesData} />
          <DriversAccess territoryId={territoryId} territoriesData={territoriesData} />
        </form.Fieldset>
      ))}
    </form.Fieldset>
  )
}
